import React from 'react';
import { Heart } from 'lucide-react';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  
  return (
    <footer className="relative py-8 px-4 bg-forest w-full z-50 bottom-0">
      <div className="absolute inset-0 bg-forest"></div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <div className="flex items-center justify-center gap-2 mb-2">
          <span className="text-sage/60 font-baskerville">Emi</span>
          <span className="text-sage/80">&</span>
          <span className="text-sage/60 font-baskerville">Carlos</span>
        </div>
        
        <p className="text-sage text-sm mb-2 font-baskerville">
          Con amor desde Ecuador, {year}
        </p>
        
        <div className="flex justify-center">
          <Heart className="w-4 h-4 text-sage/60 animate-pulse" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
